import styled, { css } from "styled-components";
import { useDesignTokens } from "@boi/react-design-tokens";

export const Container = styled.div`
  ${() => {
    const { tokens } = useDesignTokens();
    const { radio } = tokens;

    return css`
      position: relative;
      display: grid;
      place-items: center;
      width: ${radio.width};
      height: ${radio.height};
      background: ${radio.backgroundColor.base};
      border-radius: 100%;
      outline-width: ${radio.stroke.width.base};
      outline-style: ${radio.stroke.style.base};
      outline-color: ${radio.stroke.color.base};
      outline-offset: -1px;
      cursor: pointer;

      label[data-invalid] && {
        outline-width: ${radio.stroke.width.error};
        outline-color: ${radio.stroke.color.error};
      }

      label[data-hovered] && {
        outline-width: ${radio.stroke.width.hover};
        outline-color: ${radio.stroke.color.hover};
      }

      label[data-disabled] && {
        outline-width: ${radio.stroke.width.disabled};
        outline-color: ${radio.stroke.color.disabled};
        cursor: not-allowed;
      }
    `;
  }}
`;

export const SelectedIcon = styled.div`
  ${() => {
    const { tokens } = useDesignTokens();
    const { radio } = tokens;

    return [
      css`
        display: block;
        width: ${radio.icon.width};
        height: ${radio.icon.height};
        background: ${radio.icon.color.base};
        border-radius: 100%;

        label[data-hovered] && {
          background: ${radio.icon.color.hover};
        }

        label[data-disabled] && {
          background: ${radio.icon.color.disabled};
        }
      `,
    ];
  }}
`;
